import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { RegulaminHistory } from '../../../../../shared/models/regulamin';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { Button } from 'primeng/button';
import { Card } from 'primeng/card';
import { DatePipe } from '@angular/common';
import { RuleEventType } from '../../../../../shared/enums/rule-event-type.enum';
import { RuleObjectTypes } from '../../../../../shared/enums/rule-object-types.enum';
import { EnumLabelPipe } from '../../pipes/event-type-label.pipe';
import { HistoryEventDetailsComponent } from '../../../../../shared/components/history-event-details/history-event-details.component';

@Component({
  selector: 'app-admin-panel-rule-details-history-modal',
  imports: [Button, Card, DatePipe, EnumLabelPipe, HistoryEventDetailsComponent],
  templateUrl: './admin-panel-rule-details-history-modal.html',
  styleUrl: './admin-panel-rule-details-history-modal.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminPanelRuleDetailsHistoryModal {
  entry = input.required<RegulaminHistory>();
  protected readonly dialogRef = inject(DynamicDialogRef);
  public ruleEventType = RuleEventType;
  public objectType = RuleObjectTypes;

  protected close(): void {
    this.dialogRef.close();
  }
}
